module.exports = __webpack_public_path__ + "img/js.e5c42300.png";